export default {
  paragraph1: {
    id: 'dashboard_orderline_content_express_replacement_complete_paragraph1',
    defaultMessage:
      'Your Express Replacement is complete! The seller received the original device',
  },
  paragraph2: {
    id: 'dashboard_orderline_content_express_replacement_complete_paragraph2',
    defaultMessage:
      "You're all set. Now sit back, relax, and get scrolling on your replacement device.",
  },
  faqLinkLabel: {
    id: 'dashboard_orderline_content_express_replacement_complete_faq_link_label',
    defaultMessage: 'See your Express Replacement details',
  },
}
